import React from 'react';
import PropTypes from 'prop-types';
import { inject } from 'mobx-react';
import { parse } from 'querystring';
import autobind from 'autobind-decorator';

import {withI18n} from 'spa/Components/Context';
import Button from 'spa/Components/Button';
import DocumentTitle from 'spa/Components/DocumentTitle';

import './single-sign-on.less';

const isServer = typeof window === 'undefined';

const HERO_BASE_URL = isServer ?
  process.env.HERO_BASE_URL :
  window.HERO_BASE_URL;

const VALID_RETURN_URLS = isServer ?
  process.env.VALID_RETURN_URLS :
  window.VALID_RETURN_URLS;

const TRACK_CATEGORY = 'singleSignOn';

@inject(({
  store: {
    tracker,
    notifications,
  },
}) => ({
  tracker,
  notifications,
}))
@withI18n
class SingleSignOnPage extends React.Component {
  static propTypes = {
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }).isRequired,
    notifications: PropTypes.shape({
      add: PropTypes.func.isRequired,
    }).isRequired,
  }

  @autobind
  onContinueWithCustomerAccount(event) {
    event.preventDefault();
    const {tracker} = this.props;
    const {i18n} = this.context;
    const queryString = window.location.search;

    window.location.replace(`/${i18n.lc}/single-sign-on${queryString}`);

    tracker.track('Clicked single sign on with customer account', {
      category: TRACK_CATEGORY,
    });

    return false;
  }

  @autobind
  onContinueWithHeroAccount(event) {
    event.preventDefault();
    const {tracker, notifications} = this.props;
    const queryString = window.location.search;

    try {
      const getParameterByName = (name, url) => {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
        const results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      };

      const parseSso = (sso) => {
        const buffer = Buffer.from(sso, 'base64').toString();
        return parse(buffer);
      };

      const validateReturnUrl = (returnUrl) => {
        if (VALID_RETURN_URLS.indexOf(returnUrl) > -1) return;
        throw new Error('Not a valid return url');
      };

      const originalSso = getParameterByName('sso');
      const {return_sso_url} = parseSso(originalSso);

      validateReturnUrl(return_sso_url);
      window.location.replace(`${HERO_BASE_URL}/sso${queryString}&return_url=${return_sso_url}`);

      tracker.track('Clicked single sign on with hero account', {
        category: TRACK_CATEGORY,
      });
    } catch (error) {
      tracker.track('Error occured on single sign on with hero account', {
        category: TRACK_CATEGORY,
        label: error,
      });

      notifications.add({
        id: 'single-sign-on-error',
        type: 'error',
        title: this.context.i18n.__error(error),
      });
    }
    return false;
  }

  render() {
    const {onContinueWithCustomerAccount, onContinueWithHeroAccount} = this;
    const {i18n} = this.context;

    return (
      <div className="dark v-container text-center">
        <DocumentTitle title={i18n._x('Single Sign On', '<title>')} />
        <div className="container">
          <div className="single-sign-on-page__container">
            <div className="container container--medium">
              <Button
                label={i18n._x('Continue with my Urban account', 'Single Sign On page')}
                onClick={onContinueWithCustomerAccount}
                tag="button"
                theme="primary"
              />
              <Button
                label={i18n._x('Continue with my Urban Hero practitioner account', 'Single Sign On page')}
                onClick={onContinueWithHeroAccount}
                tag="button"
                theme="hero"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SingleSignOnPage;



// WEBPACK FOOTER //
// ./spa/Pages/SingleSignOn.jsx